import { AuxIcon, AuxTooltip } from "@blk/aladdin-react-components-es";
import { AuxNotificationStyleEnum, AuxNotificationToastTypeEnum } from "@blk/aladdin-web-components";
import saveFile from "file-saver";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useLazyGetCampaignSubmissionTemplateQuery } from "./store/api";
import { CampaignSubmissionTemplateKind } from "./store/types";
import { b64toBlob } from "common/file-helpers";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { addNotification } from "store/notification";
import { getCurrentLocalTime } from "common/date-utils";
const dispatchMessage = (dispatch, message, style) => {
    dispatch(addNotification({
        id: Date.now().toString(),
        message,
        notificationStyle: style,
        showMessageCount: false,
        toastType: AuxNotificationToastTypeEnum.TIMEOUT
    }));
};
const handleDownloadTemplate = async ({ loading, setLoading, dispatch, getCampaignSubmissionsTemplate, campaignId, id, disabled }) => {
    if (loading || disabled) {
        return;
    }
    appInsightsTrackEvent({
        name: appInsightEvents.customEvents.names.CampaignDownload,
        properties: { LocalTimestamp: getCurrentLocalTime() }
    });
    setLoading(true);
    dispatchMessage(dispatch, language.en.campaigns.detailsTemplateDownload.downloadInProgressMsg, AuxNotificationStyleEnum.MESSAGE);
    if (campaignId) {
        const { data } = await getCampaignSubmissionsTemplate({ campaignId, id, templateKind: CampaignSubmissionTemplateKind.SUBMITTED });
        if (data && data.content) {
            const blob = b64toBlob(data?.content, data.contentType);
            saveFile(blob, data.fileName);
            dispatchMessage(dispatch, language.en.campaigns.detailsTemplateDownload.downloadSuccessMsg, AuxNotificationStyleEnum.SUCCESS);
        }
        else {
            dispatchMessage(dispatch, language.en.campaigns.detailsTemplateDownload.downloadErrorMsg, AuxNotificationStyleEnum.ERROR);
        }
    }
    else {
        dispatchMessage(dispatch, language.en.campaigns.detailsTemplateDownload.downloadErrorMsg, AuxNotificationStyleEnum.ERROR);
    }
    setLoading(false);
};
export const InsDownloadDetailsButton = ({ campaignId, id, disabled }) => {
    const [loading, setLoading] = useState(false);
    const [getCampaignSubmissionsTemplate] = useLazyGetCampaignSubmissionTemplateQuery();
    const dispatch = useDispatch();
    const downloadTemplate = useCallback(() => {
        handleDownloadTemplate({
            campaignId,
            disabled,
            dispatch,
            getCampaignSubmissionsTemplate,
            id,
            loading,
            setLoading
        });
    }, [loading, disabled, dispatch, campaignId, getCampaignSubmissionsTemplate, id]);
    return disabled
        ? React.createElement(AuxTooltip, null,
            React.createElement("div", { slot: "target", className: "campaignDetails-download" },
                React.createElement(AuxIcon, { isDisabled: disabled, slot: "target", type: loading ? "loading" : "download", onClick: downloadTemplate })),
            React.createElement("div", { slot: "content" }, language.en.campaigns.detailsTemplateDownload.downloadUnavailableTooltip))
        : React.createElement("div", { slot: "target", className: "campaignDetails-download" },
            React.createElement(AuxIcon, { isDisabled: disabled, slot: "target", type: loading ? "loading" : "download", onClick: downloadTemplate }));
};
